import { Forms } from "@/types/form";
import { User, updateProfile } from "firebase/auth";
import { log } from "@/utils/logger";
import { auth } from "@/config/firebase";
import useUser from "@/context/user";
import { i18n } from "@/utils/i18n";

const useSubmit = () => {
    const update = useUser(state => state.update);

    const onSubmit = async (data: Forms["Profile"]) => {
        try {
            const { firstName, lastName } = data;

            if (!firstName || !lastName) return;

            await updateProfile(auth.currentUser as User, {
                displayName: `${firstName} ${lastName}`,
            });

            await update();

            log.success(i18n.t("profileUpdate", { scope: "messages.success" }));
        } catch (e) {
            log.error(e, "onSubmit");
        }
    };

    return onSubmit;
};

export { useSubmit };
